export const LIST_BLOGS = "LIST_BLOG";
export const GET_BLOG_CONTENT = "GET_BLOG";
export const LIST_BLOGS_BY_PAGE = "LIST_BLOGS_BY_PAGE";
